import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { MaintenanceSettings } from '@mp/system/maintenance/domain';

@Injectable()
export class MaintenanceSettingsService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = '/api/kernel/settings/deployment/maintenance';

  /**
   * Fetches the configured maintenance window from the backend.
   * @returns The maintenance settings.
   */
  getMaintenanceSettings(): Observable<MaintenanceSettings> {
    return this.http.get<MaintenanceSettings>(this.baseUrl);
  }

  /**
   * Saves the maintenance window to the backend.
   * @param settings The settings to save.
   * @returns The saved settings.
   */
  updateMaintenanceSettings(settings: MaintenanceSettings): Observable<MaintenanceSettings> {
    return this.http.put<MaintenanceSettings>(this.baseUrl, { ...settings });
  }
}
